<div class="left-panel-container noselect">

  <div class="panel-content">
    <div class="left-menu-container">


      <!-- VEHICLES -->
      <div class="group-wrapper ops-form w-100">
        <div class="group">
          <button mat-icon-button
                  (click)="toggleVehiclesExpansion()"
                  [attr.aria-label]="vehiclesCollapsed? 'expand vehicles' : 'collapse vehicles'"
          >
            @if (vehiclesCollapsed) {
              <mat-icon class="tree-level-button">arrow_right</mat-icon>
            } @else {
              <mat-icon class="tree-level-button">arrow_drop_down</mat-icon> <!-- expanded -->
            }
          </button>

          <div class="group-name strong">Vehicles</div>
        </div>

        @if (!vehiclesCollapsed) {
          <div>
            <app-live-vehicle-filter
              class="overlay-filter"
              (filterChanged)="onVehicleFilterChange($event)"
            >
            </app-live-vehicle-filter> <!-- this has no visible part -->
          </div>
        }
      </div>

      @if (!vehiclesCollapsed) {
        <div class="all-groups-content">
          @for (groupWithItems of vehicleGroupsWithItems; track $index; let i = $index) {
            <div class="group-content-wrapper ops-form"
                 [ngClass]="{ expanded: !groupWithItems.collapsed }"
            >
              <div class="group-wrapper">
                <div class="group">
                  <button mat-icon-button
                          (click)="toggleVehicleGroupExpansion(i)"
                          [attr.aria-label]="(groupWithItems.collapsed ? 'expand ' : 'collapse ') + groupWithItems.name"
                  >
                    @if (groupWithItems.collapsed) {
                      <mat-icon class="tree-level-button">arrow_right</mat-icon>
                    } @else {
                      <mat-icon class="tree-level-button">arrow_drop_down</mat-icon> <!-- expanded -->
                    }
                  </button>

                  <div class="group-name"
                       [ngClass]="{ hidden: !groupWithItems.visible }"
                  >
                    {{ groupWithItems.name }}
                    @if (groupWithItems.activeShiftCount > 0) {
                      <span>({{ groupWithItems.activeShiftCount }})</span>
                    }
                  </div>
                </div>

                <div class="group-actions">
                  <button mat-icon-button
                          (click)="toggleVehicleGroupVisibility(i)"
                          [attr.aria-label]="(groupWithItems.visible ? 'hide ' : 'show ') + groupWithItems.name"
                  >
                    @if (groupWithItems.visible) {
                      <mat-icon class="visibility-button">visibility</mat-icon>
                    } @else {
                      <mat-icon class="visibility-button"
                                [ngStyle]="{ display: 'block' }">
                        visibility_off
                      </mat-icon>
                    }
                  </button>
                </div>
              </div>

              @if (!groupWithItems.collapsed) {
                <div class="items">
                  @for (item of groupWithItems.items; track $index) {
                    <div class="item">
                      <app-left-menu-item
                        [input]="item"
                      ></app-left-menu-item>
                    </div>
                  }
                </div>
              }

              @if (!groupWithItems.collapsed && groupWithItems.activeShiftCount > 0) {
                <div class="offline-toggle">
                  <button mat-button
                          (click)="toggleVehicleGroupOfflineExpansion(i)"
                          class="offline-toggle-button"
                  >
                    @if (groupWithItems.offlineCollapsed) {
                      <mat-icon class="tree-level-button">keyboard_arrow_down</mat-icon>
                    } @else {
                      <mat-icon class="tree-level-button">keyboard_arrow_up</mat-icon> <!-- expanded -->
                    }
                    Offline
                  </button>

                  <!--<button mat-icon-button
                          (click)="toggleVehicleGroupOfflineVisibility(i)"

                  >
                    <mat-icon *ngIf="groupWithItems.offlineVisible" class="visibility-button">visibility</mat-icon>
                    <mat-icon *ngIf="!groupWithItems.offlineVisible"
                              class="visibility-button"
                              [ngStyle]="{ display: 'block' }"
                    >visibility_off</mat-icon>
                  </button>-->
                </div>
              }

              @if (!groupWithItems.collapsed && (!groupWithItems.offlineCollapsed || groupWithItems.activeShiftCount === 0)) {
                <div class="items">
                  @for (item of groupWithItems.offlineItems; track $index) {
                    <div class="item">
                      <app-left-menu-item
                        [input]="item"
                      ></app-left-menu-item>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }


      <!-- ROUTES -->
      <div class="group-wrapper ops-form">
        <div class="group">
          <button mat-icon-button
                  (click)="toggleRoutesExpansion()"
                  [attr.aria-label]="routesCollapsed? 'expand routes' : 'collapse routes'"
          >
            @if (routesCollapsed) {
              <mat-icon class="tree-level-button">arrow_right</mat-icon>
            } @else {
              <mat-icon class="tree-level-button">arrow_drop_down</mat-icon>
            }
          </button>

          <div class="group-name strong">Routes</div>
        </div>
      </div>

      @if (!routesCollapsed) {
        <div class="all-groups-content">
          @for (routeHierarchyItem of routeItems; track $index) {
            <app-route-group-menu
              [path]="[]"
              [routeHierarchyItem]="routeHierarchyItem"
              class="route-configuration-menu-item"
            >
            </app-route-group-menu>
          }
        </div>
      }


      <!-- INSIGHTS -->
      <div class="group-wrapper ops-form">
        <div class="group">
          <button mat-icon-button
                  (click)="toggleInsightsExpansion()"
                  [attr.aria-label]="insightsCollapsed? 'expand insights' : 'collapse insights'"
          >
            @if (insightsCollapsed) {
              <mat-icon class="tree-level-button">arrow_right</mat-icon>
            } @else {
              <mat-icon class="tree-level-button">arrow_drop_down</mat-icon>
            }
          </button>

          <div class="group-name strong">Insights</div>
        </div>
      </div>

      @if (!insightsCollapsed) {
        <div class="insights-items">
          @for (item of insightsSections; track $index) {
            <div>
              <app-action-menu-item
                [input]="item"
              ></app-action-menu-item>
              @if (activeItem?.type === LeftPanelSection.INSIGHTS) {
                @if (item.id === InsightsRoute.SHIFT_REPORT && activeItem.insightName === InsightsRoute.SHIFT_REPORT && activeItem.shiftId) {
                  <div class="shift-detail-close-button">
                    <span> Shift {{ activeItem.shiftId }}</span>
                    <button mat-icon-button (click)="selectReport(InsightsRoute.SHIFT_REPORT)">
                      <mat-icon>close</mat-icon>
                    </button>
                  </div>
                } @else if (item.id === InsightsRoute.SHIFT_LOOKUP && activeItem.insightName === InsightsRoute.SHIFT_LOOKUP && activeItem.shiftId) {
                  <div class="shift-detail-close-button">
                    <span> Shift {{ activeItem.shiftId }}</span>
                    <button mat-icon-button (click)="selectReport(InsightsRoute.SHIFT_LOOKUP)">
                      <mat-icon>close</mat-icon>
                    </button>
                  </div>
                }
              }
            </div>
          }
        </div>
      }

    </div>

  </div>

</div>
